(function(){
  if(window.__scnvInit) return; window.__scnvInit = true;
  // 异步加载 Google Fonts:失败静默回退,永不阻塞渲染(国内网络兼容)
  try {
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;1,300;1,400&family=Inter:wght@400;500;600&display=swap';
    l.media = 'print';
    l.onload = function(){ this.media = 'all'; };
    document.head.appendChild(l);
  } catch(e){}
  function init(){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('scnv-in'); io.unobserve(e.target); } });
    },{threshold:0.12});
    document.querySelectorAll('.scnv-reveal').forEach(function(el){ io.observe(el); });
    var hero = document.querySelector('.scnv-hero');
    if(hero){ setTimeout(function(){ hero.classList.add('scnv-on'); }, 400); }
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
